import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FeatureToggleModule, QaLocatorsModule } from '@metromarkets/sdk';
import { MmIconModule } from '@metromarkets/components';

import { MediaControlModule } from '~shared/modules/media-control/media-control.module';
import { AddressComponent } from './components/address/address.component';
import { AddressActionsButtonComponent } from './components/address-actions-button/address-actions-button.component';
import { AddressDetailsComponent } from './components/address-details/address-details.component';

@NgModule({
  declarations: [
    AddressComponent,
    AddressActionsButtonComponent,
    AddressDetailsComponent,
  ],
  imports: [
    CommonModule,
    QaLocatorsModule,
    TranslateModule,
    MmIconModule,
    MediaControlModule,
    FeatureToggleModule,
  ],
  exports: [
    AddressComponent,
    AddressDetailsComponent,
  ],
})
export class AddressesModule {}
